import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const themesAPI = {
    getConfig: () => api.get('/api/themes/config'),
    updateConfig: (config) => api.put('/api/themes/config', config),
    uploadLogo: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/api/themes/logo', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    deleteLogo: () => api.delete('/api/themes/logo'),
    applySuggestedTheme: () => api.post('/api/themes/apply-suggested'),
    resetTheme: () => api.post('/api/themes/reset'),
    getLogoUrl: (empresaId) => `${API_URL}/api/themes/logo/${empresaId}`,
};

export default api;
